<div class='activity-container'>
  <div class='activity-container-header'>
    <span *ngIf='showDate' class='display-date'>
      {{currentDate.format() | date }}
    </span>
  </div>
  <div class='activity-container-body'>
    <div class='history-nav'>
      <nb-icon
        (click)='goBack()'
        *ngIf='showNavigation'
        icon='arrow-ios-back-outline'
        nbPrefix
        pack='eva'
      ></nb-icon>
    </div>
    <div (chartInit)='onChartInit($event)'
         *ngIf='updateOptions'
         [class]='style'
         [initOpts]='initOps'
         [merge]='updateOptions'
         [options]='options'
         class='e-chart'
         echarts id='activityChart'></div>
    <div class='history-nav'>
      <nb-icon
        (click)='goForward()'
        *ngIf='showNavigation && showForward'
        icon='arrow-ios-forward-outline'
        nbPrefix
        pack='eva'
      ></nb-icon>
    </div>
  </div>
</div>
